import {subdebug} from '@sanity/cli-core'

export const schemasDeployDebug = subdebug('schemas:deploy')
export const schemasListDebug = subdebug('schemas:list')
export const schemasExtractDebug = subdebug('schemas:extract')
